import { ProfileFieldCategory, ProfileTypes } from "src/services/apiService/response-models";

export default function filterProfileFields(categories: ProfileFieldCategory[], type: ProfileTypes): ProfileFieldCategory[] {
  const results = [...categories].filter(o => !o.profileType || o.profileType == type);
  results.forEach(o => {
    o.fields = o.fields.filter(f => !f.profileType || f.profileType == type)
  })
  return results;
}